import React from 'react'
import { Check } from 'react-bootstrap-icons'

const toggle = (values, value) =>
  values.includes(value) ? values.filter((v) => v !== value) : [...values, value]

/**
 * Multi-select as chips rather than a row of loose checkboxes — the selected
 * set stays readable at a glance, which is the whole point when the field
 * decides where something is shown.
 *
 * `options` accepts the same shapes as FormField: { value, label }, { _id, name }
 * or bare strings.
 */
const ChipGroup = ({ options = [], value = [], onChange, getLabel }) => {
  const resolve = (option) => {
    if (typeof option === 'string' || typeof option === 'number') {
      return { value: option, label: getLabel ? getLabel(option) : String(option) }
    }
    const optionValue = option.value !== undefined ? option.value : option._id
    return {
      value: optionValue,
      label: option.label !== undefined ? option.label : option.name,
    }
  }

  return (
    <div className='app-modal__chips'>
      {options.map((option) => {
        const item = resolve(option)
        const selected = value.includes(item.value)
        return (
          <button
            key={item.value}
            type='button'
            className={`app-modal__chip ${selected ? 'app-modal__chip--on' : ''}`.trim()}
            aria-pressed={selected}
            onClick={() => onChange(toggle(value, item.value))}
          >
            <span className='app-modal__chip-box'>{selected && <Check />}</span>
            {item.label}
          </button>
        )
      })}
    </div>
  )
}

/**
 * The day-of-week picker. Same interaction as ChipGroup, tighter form because
 * seven fixed-width pills read as a week.
 */
export const DayPicker = ({ days = [], value = [], onChange, clearLabel }) => (
  <div className='app-modal__chips'>
    {days.map((day) => {
      const selected = value.includes(day.value)
      return (
        <button
          key={day.value}
          type='button'
          className={`app-modal__day ${selected ? 'app-modal__day--on' : ''}`.trim()}
          aria-pressed={selected}
          onClick={() =>
            onChange(toggle(value, day.value).sort((a, b) => a - b))
          }
        >
          {day.short}
        </button>
      )
    })}
    {value.length > 0 && clearLabel && (
      <button
        type='button'
        className='btn btn-sm btn-light-danger ms-2'
        onClick={() => onChange([])}
      >
        {clearLabel}
      </button>
    )}
  </div>
)

export default ChipGroup
